import { useMediaQuery } from '@mui/material';
import { BasePage, Carousel, DealGrid } from 'components';

export function HomePage() {
    const mobile = useMediaQuery("(max-width:600px)");

    return (
        <BasePage>
            <Carousel
                slidesToShow={mobile ? 1 : 3}
                padding={mobile ? 0 : 1}
                borderRadius={"25px"}
                spacing={2}
            />
            {/* FEATURE: Have sponsored ordered by paid tier for home page */}
            <DealGrid />
        </BasePage>
    );
}